import styles from './pages.module.scss';
import WrappedSvg1 from '../../../../../assets/svg/wrapped/randoms/1.svg';
import WrappedSvg2 from '../../../../../assets/svg/wrapped/randoms/2.svg';
import WrappedSvg3 from '../../../../../assets/svg/wrapped/randoms/3.svg';
import WrappedSvg4 from '../../../../../assets/svg/wrapped/randoms/4.svg';
import WrappedSvg5 from '../../../../../assets/svg/wrapped/randoms/5.svg';
import WrappedSvg6 from '../../../../../assets/svg/wrapped/randoms/6.svg';
import WrappedSvg7 from '../../../../../assets/svg/wrapped/randoms/7.svg';
import WrappedSvg8 from '../../../../../assets/svg/wrapped/randoms/8.svg';
import WrappedSvg9 from '../../../../../assets/svg/wrapped/randoms/9.svg';
import WrappedSvg10 from '../../../../../assets/svg/wrapped/randoms/10.svg';

const wrappedSvg = [
  WrappedSvg1,
  WrappedSvg2,
  WrappedSvg3,
  WrappedSvg4,
  WrappedSvg5,
  WrappedSvg6,
  WrappedSvg7,
  WrappedSvg8,
  WrappedSvg9,
  WrappedSvg10,
];

const RandomType = () => {
  // Seleziona un numero random 1-10 per ogni render del modal
  const randomIndex = Math.floor(Math.random() * 10); // 0-9
  return (
    <div className={styles.card}>
      {randomIndex && <img 
        src={wrappedSvg[randomIndex] || WrappedSvg1} 
        alt="Wrapped" 
        className={styles.background_image} 
      />}
    </div>
  );
};

export default RandomType;
